import { AxiosError } from "axios";
export function normalizeAxiosError(error) {
    if (error instanceof AxiosError) {
        const apiMessage = error.response?.data?.message || error.response?.statusText;
        return new Error(apiMessage || error.message || "Unknown API error");
    }
    if (error instanceof Error)
        return error;
    return new Error("Unexpected error");
}
